import axios from "axios";
import { API_BASE_URL } from "@/shared/config";

let onUnauthorizedCallback: (() => void) | null = null;

export const setOnUnauthorizedCallback = (cb: (() => void) | null) => {
  onUnauthorizedCallback = cb;
};

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      console.warn("Сессия истекла или отсутствует кука авторизации.");
      onUnauthorizedCallback?.();
    }
    return Promise.reject(error);
  }
);
